import { IPublicClientApplication } from '@azure/msal-browser';

export const getAuthToken = async (msalInstance: IPublicClientApplication, scopes: string[]) => {
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw new Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
  }

  await msalInstance.initialize();
  const response = await msalInstance.acquireTokenSilent({
    scopes: scopes,
    account,
  });

  return { accessToken: response.accessToken, expiry: response.expiresOn };
};
